import { getSpace as spaceFn } from './space.utils';
// Default space.
// -----------------------------------------------------------------------------
export const space = {
    space: spaceFn
};
//# sourceMappingURL=space.js.map